var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.622 2.85 3.394 3.395L6.49 16.822l-3.689.293.293-3.686zm.002 2.124-9.08 9.122-.11 1.385 1.383-.11 9.08-9.124z",
    clipRule: "evenodd"
  })));
};
export { SvgPencil as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy42MjE4IDIuODUwMUwxNy4wMTYzIDYuMjQ0NTJMNi40ODg3OCAxNi44MjJMMi44IDE3LjExNTRMMy4wOTMyNyAxMy40Mjg2TDEzLjYyMTggMi44NTAxWk0xMy42MjQ0IDQuOTczOTNMNC41NDQ4OCAxNC4wOTY1TDQuNDM0NzggMTUuNDgwNkw1LjgxNjkgMTUuMzcwN0wxNC44OTc1IDYuMjQ3MDNMMTMuNjI0NCA0Ljk3MzkzWiIvPgo8L3N2Zz4K";